// The app's version, shown as small text in the header. Raised with each release to main.
export const APP_VERSION = 'v1.00';
